export default function ChevronDownIcon() {
    return (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.7931 0.732718C12.0787 1.03264 12.0672 1.50737 11.7673 1.79307L6.51682 6.7944C6.22715 7.07032 5.77191 7.07032 5.48224 6.7944L0.231777 1.79307C-0.0681448 1.50737 -0.0796814 1.03264 0.20601 0.732718C0.491701 0.432796 0.966434 0.421259 1.26636 0.706951L5.99953 5.21554L10.7327 0.70695C11.0326 0.421259 11.5074 0.432796 11.7931 0.732718Z" fill="#C00D0D"/>
        </svg>
    );
};